import { IFiltrosItensLote } from "../interfaces/IFiltrosItensLote";
import { IOrdenacao } from "../interfaces/IOrdenacao";

interface IParametrosBuscaItensLote {
  filtros: IFiltrosItensLote;
  ordenacao: IOrdenacao;
  pagina: number;
  limite: number;
}

export function montarParametrosItensLote({
  filtros,
  ordenacao,
  pagina,
  limite,
}: IParametrosBuscaItensLote): URLSearchParams {
  const parametros = new URLSearchParams({
    pagina: String(pagina),
    limite: String(limite),
    ordenarPor: ordenacao.campo,
    ordem: ordenacao.direcao,
  });

  filtros.placa.forEach((placa) => parametros.append("placa", placa));
  if (filtros.prensa !== null) parametros.set("prensa", String(filtros.prensa));
  if (filtros.statusAutorizacao !== null)
    parametros.set("statusAutorizacao", String(filtros.statusAutorizacao));
  if (filtros.statusProducao !== null)
    parametros.set("statusProducao", String(filtros.statusProducao));
  if (filtros.idEmpresa !== null)
    parametros.set("idEmpresa", String(filtros.idEmpresa));
  filtros.idProcesso.forEach((idProcesso) =>
    parametros.append("idProcesso", idProcesso)
  );

  return parametros;
}
